var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBnbChain(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13552_12084)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_13552_12084)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26 0C40.3604 0 52 11.6396 52 26C52 40.3604 40.3604 52 26 52C11.6396 52 0 40.3604 0 26C0 11.6396 11.6396 0 26 0Z",
    fill: "#F0B90B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2895 26.0001L14.3083 32.8751L20.15 36.3126V40.3376L10.8895 34.9063V23.9897L14.2895 26.0001ZM14.2895 19.1251V23.1313L10.8875 21.1188V17.1126L14.2895 15.1001L17.7083 17.1126L14.2895 19.1251ZM22.5895 17.1126L25.9916 15.1001L29.4104 17.1126L25.9916 19.1251L22.5895 17.1126Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.7478 31.4501V27.4251L20.1499 29.4376V33.4438L16.7478 31.4501ZM22.5895 37.7543L25.9916 39.7668L29.4103 37.7543V41.7605L25.9916 43.773L22.5895 41.7605V37.7543ZM34.2895 17.1126L37.6916 15.1001L41.1103 17.1126V21.1188L37.6916 23.1313V19.1251L34.2895 17.1126ZM37.6916 32.8751L37.7103 26.0001L41.1124 23.9876V34.9043L31.852 40.3355V36.3105L37.6916 32.8751Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.2522 31.45L31.8501 33.4438V29.4375L35.2522 27.425V31.45Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.252 20.55L35.2707 24.575L29.4124 28.0125V34.9041L26.0103 36.8979L22.6082 34.9041V28.0125L16.7499 24.575V20.55L20.1666 18.5375L25.9895 21.9916L31.8478 18.5375L35.2666 20.55H35.252ZM16.7478 13.6771L25.9916 8.22705L35.252 13.6771L31.8499 15.6895L25.9916 12.2354L20.1499 15.6895L16.7478 13.6771Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13552_12084"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 52,
    height: 52,
    rx: 26,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_13552_12084"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 52,
    height: 52,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBnbChain);
export default __webpack_public_path__ + "static/media/BNB-Chain.073acc8d4a9bfcffb574af5464ef83de.svg";
export { ForwardRef as ReactComponent };